export const BUILD_INFO = {
  "version": "2.2.0",
  "buildTime": "2026-11-03 09:02:47",
  "commit": "unknown",
  "buildNumber": "local"
};